import React from "react"

const SpacingComponent = () => {
  return <div className="spacingHeight16" style={{ height: "16px" }} />
}

export default SpacingComponent
